"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var GlobalEventStore =
/** @class */
function () {
  function GlobalEventStore() {
    this.subscriptionsByGlobalEvent = {};
  }

  GlobalEventStore.prototype.getSubscribers = function (event) {
    return this.subscriptionsByGlobalEvent && this.subscriptionsByGlobalEvent[event];
  };

  GlobalEventStore.prototype.subscribe = function (subscription) {
    if (!this.subscriptionsByGlobalEvent) {
      this.subscriptionsByGlobalEvent = {};
    }

    var event = subscription.event,
        subscriptionId = subscription.subscriptionId;

    if (!this.subscriptionsByGlobalEvent[event]) {
      this.subscriptionsByGlobalEvent[event] = [];
    }

    if (!subscriptionId || !this.subscriptionsByGlobalEvent[event].find(function (existingSubscription) {
      return existingSubscription.subscriptionId === subscriptionId;
    })) {
      this.subscriptionsByGlobalEvent[event].push(subscription);
      console.info("Global Events: Subscription added for: " + event);
    }
  };

  GlobalEventStore.prototype.publish = function (eventWithPayload) {
    var event = eventWithPayload.event,
        payload = eventWithPayload.payload;
    console.info("Global Events: Publish fired for: " + event, {
      payload: payload && JSON.parse(JSON.stringify(payload))
    });
    var subscribers = this.getSubscribers(event);
    console.info("Global Events: " + (subscribers && subscribers.length || 0) + " subscribers for: " + event);

    if (subscribers) {
      subscribers.forEach(function (subscriber) {
        subscriber.onPublish(payload);
      });
    }
  };

  return GlobalEventStore;
}();

exports.GlobalEventStore = GlobalEventStore;